import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { createAppClinteSchema } from "backend/src/schemas/appClinteSchema";

export interface AppClient {
    appClientId: string;
    clientName: string;
    organisationId: string;
    clientSecret: string;
  }

type OrgAppClientResponseType = ResponseType<AppClient>;

function useAppClientMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<OrgAppClientResponseType>["response"],
    AxiosResponseAndError<OrgAppClientResponseType>["error"],
    z.infer<typeof createAppClinteSchema>
  >({
    mutationFn: async (data) => {
      return ApiRequest.post<OrgAppClientResponseType>(
        `${requestURLs.createAppClient}`,
        data
      );
    },
  });

  return mutation;
}

export default useAppClientMutation;
